var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.549 13.6262L13.6262 13.549C13.3748 13.8003 12.9756 13.8005 12.7295 13.5543L8.52717 9.352C7.63175 10.0689 6.49892 10.5 5.236 10.5C2.34442 10.5 0 8.14975 0 5.25V5.1275C0 2.29542 2.28958 0 5.11408 0H5.24592C8.16317 0 10.5 2.34442 10.5 5.25C10.5 6.49017 10.0689 7.62825 9.35142 8.52658L13.5543 12.7294C13.8003 12.9754 13.7981 13.3771 13.549 13.6262ZM5.23775 9.33333C7.50706 9.33333 9.33333 7.50145 9.33333 5.25C9.33333 2.99294 7.49992 1.16667 5.24643 1.16667H5.13107C2.94496 1.16667 1.16667 2.95057 1.16667 5.14281V5.25C1.16667 7.50145 2.99294 9.33333 5.23775 9.33333Z",
    fill: "#353029"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSmall);
export default __webpack_public_path__ + "static/media/search-small.5f5d214fba0ec6409769fa0ae4c81b05.svg";
export { ForwardRef as ReactComponent };